import { ChangeDetectionStrategy, Component } from '@angular/core';

import { Observable } from '../util/rxjs';
import { Action, Dialog, DialogMessage } from './dialog.model';
import { DialogService } from './dialog.service';

@Component({
  selector: 'cp-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogComponent {
  dialogs$: Observable<Dialog>;

  constructor(private dialogService: DialogService) {
    this.dialogs$ = dialogService.dialogs$;
  }

  execute(action: Action) {
    action.execute();
    this.dialogService.dismiss();
  }

  hasParams(message: DialogMessage): message is DialogMessage {
    return typeof message !== 'string';
  }
}
